import layout from './ThirdPartyComponentsView.html?raw';
import View from '@/Views/View';
import ComponentManager from '@/Management/ComponentManager';
import ThirdPartyComponentsViewViewModel from '@/Components/ThirdPartyComponentsView/ThirdPartyComponentsViewViewModel';

export default class ThirdPartyComponentsView extends View {
    private view: JQuery<HTMLElement>;

    public constructor(private viewModel: ThirdPartyComponentsViewViewModel, private element?: JQuery<HTMLElement>) {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, layout);

        return this.view;
    }
}

ComponentManager.setView('ThirdPartyComponentsView', ThirdPartyComponentsView, 'RADPresentation.HTMLClient.DefaultViewExtensions');